import { privateRequest, type ApiResponse } from "../axios";

const ENDPOINTS = {
    USER_REPORTS: "api/User-Report-Details",
    USER_REPORT_DATA: "api/UserReportData",
    USER_REPORTS_EXPORT: "api/UserReportDetails/Export",
}

const getUserReportDetails = async (params: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.USER_REPORTS, { params: params });
    return res.data;
};

const getUserReportData = async (params: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.USER_REPORT_DATA, { params: params });
    return res.data;
};

const getUserReportExport = async (params: any): Promise<any> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.USER_REPORTS_EXPORT, { params: params, responseType: "arraybuffer" });
    return res;
};

const UserReport = {
    getUserReportDetails,
    getUserReportData,
    getUserReportExport,
}

export default UserReport;